import * as React from 'react';
import styles from './StickySidebar.css';

export const StickySidebar = ({ children }) => {
  return(
    <div className={styles['sticky-range']}>
      <div className={styles['sticky-element']}>
        {children}
      </div>
    </div>
  );
};